export const HedaerLogoDesktop = () => {
    return (
        <svg width="161" height="34" viewBox="0 0 161 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="135" width="6" height="6" fill="#FF8585" />
            <rect x="145" width="6" height="6" fill="#FFB84F" />
            <rect x="155" width="6" height="6" fill="#7AE448" />
            <path d="M0 33.4286V6H22.6007V33.4286H17.9334V10.3048H4.66732V33.4286H0Z" fill="white" />
            <path d="M36.4916 34C34.4 34 32.5731 33.5365 31.0109 32.6095C29.4486 31.6825 28.235 30.4064 27.37 28.781C26.5179 27.1429 26.0918 25.2635 26.0918 23.1429C26.0918 20.9841 26.5308 19.0921 27.4087 17.4667C28.2867 15.8413 29.5067 14.5714 31.069 13.6571C32.6312 12.7429 34.4387 12.2857 36.4916 12.2857C38.5961 12.2857 40.4294 12.7492 41.9917 13.6762C43.5539 14.6032 44.7675 15.8857 45.6326 17.5238C46.4976 19.1492 46.9301 21.0222 46.9301 23.1429C46.9301 25.2762 46.4911 27.1619 45.6132 28.8C44.7482 30.4254 43.5345 31.7016 41.9723 32.6286C40.4101 33.5429 38.5832 34 36.4916 34ZM36.4916 29.6952C38.3508 29.6952 39.7322 29.0857 40.636 27.8667C41.5398 26.6476 41.9917 25.073 41.9917 23.1429C41.9917 21.1492 41.5333 19.5619 40.6166 18.381C39.7 17.1873 38.3249 16.5905 36.4916 16.5905C35.2392 16.5905 34.2063 16.8698 33.393 17.4286C32.5925 17.9746 31.9986 18.7429 31.6112 19.7333C31.2239 20.7111 31.0302 21.8476 31.0302 23.1429C31.0302 25.1365 31.4886 26.7302 32.4053 27.9238C33.3349 29.1048 34.697 29.6952 36.4916 29.6952Z" fill="white" />
            <path d="M48.4858 33.4286V29.581C49.2475 29.7206 49.835 29.7079 50.2481 29.5429C50.6613 29.3651 50.9712 29.0349 51.1777 28.5524C51.3843 28.0698 51.5651 27.4286 51.72 26.6286C51.9266 25.4984 52.1073 24.1968 52.2623 22.7238C52.4301 21.2508 52.5721 19.6762 52.6883 18C52.8174 16.3238 52.9336 14.6095 53.0369 12.8571H68.4333V33.4286H63.7853V17.1619H57.1426C57.0781 17.9873 57.0006 18.9143 56.9102 19.9429C56.8198 20.9587 56.723 21.9873 56.6197 23.0286C56.5164 24.0698 56.4002 25.0603 56.2711 26C56.1549 26.927 56.0323 27.7206 55.9031 28.381C55.6062 29.8667 55.1801 31.0413 54.625 31.9048C54.0827 32.7683 53.321 33.3206 52.3397 33.5619C51.3585 33.8159 50.0738 33.7714 48.4858 33.4286Z" fill="white" />
            <path d="M73.08 33.4286L73.0606 12.8571H77.728V19.7143H81.4851C82.066 19.7143 82.7181 19.727 83.4411 19.7524C84.177 19.7778 84.7903 19.8349 85.2809 19.9238C86.4558 20.1778 87.4564 20.5841 88.2827 21.1429C89.1219 21.7016 89.761 22.4317 90.2 23.3333C90.6389 24.2349 90.8584 25.3206 90.8584 26.5905C90.8584 28.4064 90.3807 29.8603 89.4253 30.9524C88.4828 32.0317 87.153 32.7683 85.4358 33.1619C84.9194 33.2762 84.2867 33.3524 83.5379 33.3905C82.802 33.4159 82.1371 33.4286 81.5432 33.4286H73.08ZM77.728 29.8286H81.9499C82.2339 29.8286 82.5502 29.8159 82.8988 29.7905C83.2474 29.7651 83.5831 29.7079 83.9059 29.619C84.4869 29.4667 84.9968 29.1238 85.4358 28.5905C85.8877 28.0444 86.1136 27.3778 86.1136 26.5905C86.1136 25.7651 85.8877 25.0857 85.4358 24.5524C84.9839 24.019 84.4288 23.6698 83.7703 23.5048C83.4734 23.4286 83.1635 23.3778 82.8407 23.3524C82.5179 23.327 82.221 23.3143 81.9499 23.3143H77.728V29.8286Z" fill="white" />
            <path d="M101.776 34C99.7874 34 97.9734 33.5873 96.3337 32.7619C94.694 31.9365 93.4029 30.8064 92.4604 29.3714L96.14 26.9524C96.8889 27.8286 97.7216 28.5079 98.6383 28.9905C99.555 29.4603 100.575 29.6952 101.698 29.6952C102.873 29.6952 103.796 29.4413 104.468 28.9333C105.139 28.4254 105.475 27.746 105.475 26.8952C105.475 26.146 105.249 25.619 104.797 25.3143C104.345 24.9968 103.751 24.8064 103.015 24.7429C102.279 24.6794 101.492 24.6476 100.652 24.6476H99.1031V21.0095H100.633C101.808 21.0095 102.789 20.8762 103.577 20.6095C104.377 20.3429 104.777 19.7524 104.777 18.8381C104.777 18.0127 104.468 17.4286 103.848 17.0857C103.228 16.7302 102.505 16.5524 101.679 16.5524C100.672 16.5524 99.6776 16.7619 98.6964 17.181C97.7152 17.6 96.8372 18.1079 96.0626 18.7048L93.4287 15.581C94.5907 14.5651 95.8883 13.7651 97.3214 13.181C98.7545 12.5841 100.284 12.2857 101.911 12.2857C103.254 12.2857 104.506 12.5143 105.668 12.9714C106.843 13.4286 107.786 14.1143 108.496 15.0286C109.219 15.9429 109.58 17.073 109.58 18.419C109.58 19.3841 109.367 20.2921 108.941 21.1429C108.528 21.9937 107.863 22.8 106.947 23.5619L106.888 22.0762C107.599 22.3683 108.199 22.7746 108.69 23.2952C109.193 23.8159 109.574 24.4254 109.832 25.1238C110.103 25.8222 110.239 26.5651 110.239 27.3524C110.239 28.7873 109.851 30 109.077 30.9905C108.302 31.981 107.269 32.7302 105.978 33.2381C104.7 33.746 103.299 34 101.776 34Z" fill="white" />
            <path d="M119.574 34C118.063 34 116.785 33.7206 115.739 33.1619C114.693 32.5905 113.899 31.8349 113.357 30.8952C112.828 29.9556 112.563 28.9206 112.563 27.7905C112.563 26.8 112.731 25.9111 113.067 25.1238C113.402 24.3238 113.919 23.6381 114.616 23.0667C115.313 22.4825 116.217 22.0063 117.327 21.6381C118.166 21.3714 119.148 21.1302 120.271 20.9143C121.407 20.6984 122.634 20.5016 123.951 20.3238C125.28 20.1333 126.668 19.9302 128.114 19.7143L126.449 20.6476C126.462 19.2254 126.139 18.1778 125.481 17.5048C124.822 16.8317 123.712 16.4952 122.15 16.4952C121.207 16.4952 120.297 16.7111 119.419 17.1429C118.541 17.5746 117.928 18.3175 117.579 19.3714L113.318 18.0571C113.835 16.3175 114.816 14.9206 116.262 13.8667C117.721 12.8127 119.684 12.2857 122.15 12.2857C124.009 12.2857 125.642 12.5841 127.049 13.181C128.469 13.7778 129.522 14.7556 130.206 16.1143C130.58 16.8381 130.806 17.581 130.884 18.3429C130.961 19.0921 131 19.9111 131 20.8V33.4286H126.914V28.9714L127.592 29.6952C126.649 31.181 125.545 32.273 124.28 32.9714C123.027 33.6571 121.459 34 119.574 34ZM120.503 30.3429C121.562 30.3429 122.466 30.1587 123.215 29.7905C123.964 29.4222 124.557 28.9714 124.996 28.4381C125.448 27.9048 125.752 27.4032 125.907 26.9333C126.152 26.3492 126.287 25.6825 126.313 24.9333C126.352 24.1714 126.371 23.5556 126.371 23.0857L127.805 23.5048C126.397 23.7206 125.19 23.9111 124.183 24.0762C123.176 24.2413 122.311 24.4 121.588 24.5524C120.865 24.6921 120.226 24.8508 119.671 25.0286C119.128 25.219 118.67 25.4413 118.296 25.6952C117.921 25.9492 117.631 26.2413 117.424 26.5714C117.23 26.9016 117.134 27.2889 117.134 27.7333C117.134 28.2413 117.263 28.6921 117.521 29.0857C117.779 29.4667 118.154 29.7714 118.644 30C119.148 30.2286 119.767 30.3429 120.503 30.3429Z" fill="white" />
        </svg>

    );
}

export const HeaderLogoTablet = () => {
    return (
        <svg width="161" height="34" viewBox="0 0 161 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="135" width="6" height="6" fill="#FF8585" />
            <rect x="145" width="6" height="6" fill="#FFB84F" />
            <rect x="155" width="6" height="6" fill="#7AE448" />
            <path d="M0 33.4286V6H22.6007V33.4286H17.9334V10.3048H4.66732V33.4286H0Z" fill="white" />
            <path d="M36.4916 34C34.4 34 32.5731 33.5365 31.0109 32.6095C29.4486 31.6825 28.235 30.4064 27.37 28.781C26.5179 27.1429 26.0918 25.2635 26.0918 23.1429C26.0918 20.9841 26.5308 19.0921 27.4087 17.4667C28.2867 15.8413 29.5067 14.5714 31.069 13.6571C32.6312 12.7429 34.4387 12.2857 36.4916 12.2857C38.5961 12.2857 40.4294 12.7492 41.9917 13.6762C43.5539 14.6032 44.7675 15.8857 45.6326 17.5238C46.4976 19.1492 46.9301 21.0222 46.9301 23.1429C46.9301 25.2762 46.4911 27.1619 45.6132 28.8C44.7482 30.4254 43.5345 31.7016 41.9723 32.6286C40.4101 33.5429 38.5832 34 36.4916 34ZM36.4916 29.6952C38.3508 29.6952 39.7322 29.0857 40.636 27.8667C41.5398 26.6476 41.9917 25.073 41.9917 23.1429C41.9917 21.1492 41.5333 19.5619 40.6166 18.381C39.7 17.1873 38.3249 16.5905 36.4916 16.5905C35.2392 16.5905 34.2063 16.8698 33.393 17.4286C32.5925 17.9746 31.9986 18.7429 31.6112 19.7333C31.2239 20.7111 31.0302 21.8476 31.0302 23.1429C31.0302 25.1365 31.4886 26.7302 32.4053 27.9238C33.3349 29.1048 34.697 29.6952 36.4916 29.6952Z" fill="white" />
            <path d="M48.4858 33.4286V29.581C49.2475 29.7206 49.835 29.7079 50.2481 29.5429C50.6613 29.3651 50.9712 29.0349 51.1777 28.5524C51.3843 28.0698 51.5651 27.4286 51.72 26.6286C51.9266 25.4984 52.1073 24.1968 52.2623 22.7238C52.4301 21.2508 52.5721 19.6762 52.6883 18C52.8174 16.3238 52.9336 14.6095 53.0369 12.8571H68.4333V33.4286H63.7853V17.1619H57.1426C57.0781 17.9873 57.0006 18.9143 56.9102 19.9429C56.8198 20.9587 56.723 21.9873 56.6197 23.0286C56.5164 24.0698 56.4002 25.0603 56.2711 26C56.1549 26.927 56.0323 27.7206 55.9031 28.381C55.6062 29.8667 55.1801 31.0413 54.625 31.9048C54.0827 32.7683 53.321 33.3206 52.3397 33.5619C51.3585 33.8159 50.0738 33.7714 48.4858 33.4286Z" fill="white" />
            <path d="M73.08 33.4286L73.0606 12.8571H77.728V19.7143H81.4851C82.066 19.7143 82.7181 19.727 83.4411 19.7524C84.177 19.7778 84.7903 19.8349 85.2809 19.9238C86.4558 20.1778 87.4564 20.5841 88.2827 21.1429C89.1219 21.7016 89.761 22.4317 90.2 23.3333C90.6389 24.2349 90.8584 25.3206 90.8584 26.5905C90.8584 28.4064 90.3807 29.8603 89.4253 30.9524C88.4828 32.0317 87.153 32.7683 85.4358 33.1619C84.9194 33.2762 84.2867 33.3524 83.5379 33.3905C82.802 33.4159 82.1371 33.4286 81.5432 33.4286H73.08ZM77.728 29.8286H81.9499C82.2339 29.8286 82.5502 29.8159 82.8988 29.7905C83.2474 29.7651 83.5831 29.7079 83.9059 29.619C84.4869 29.4667 84.9968 29.1238 85.4358 28.5905C85.8877 28.0444 86.1136 27.3778 86.1136 26.5905C86.1136 25.7651 85.8877 25.0857 85.4358 24.5524C84.9839 24.019 84.4288 23.6698 83.7703 23.5048C83.4734 23.4286 83.1635 23.3778 82.8407 23.3524C82.5179 23.327 82.221 23.3143 81.9499 23.3143H77.728V29.8286Z" fill="white" />
            <path d="M101.776 34C99.7874 34 97.9734 33.5873 96.3337 32.7619C94.694 31.9365 93.4029 30.8064 92.4604 29.3714L96.14 26.9524C96.8889 27.8286 97.7216 28.5079 98.6383 28.9905C99.555 29.4603 100.575 29.6952 101.698 29.6952C102.873 29.6952 103.796 29.4413 104.468 28.9333C105.139 28.4254 105.475 27.746 105.475 26.8952C105.475 26.146 105.249 25.619 104.797 25.3143C104.345 24.9968 103.751 24.8064 103.015 24.7429C102.279 24.6794 101.492 24.6476 100.652 24.6476H99.1031V21.0095H100.633C101.808 21.0095 102.789 20.8762 103.577 20.6095C104.377 20.3429 104.777 19.7524 104.777 18.8381C104.777 18.0127 104.468 17.4286 103.848 17.0857C103.228 16.7302 102.505 16.5524 101.679 16.5524C100.672 16.5524 99.6776 16.7619 98.6964 17.181C97.7152 17.6 96.8372 18.1079 96.0626 18.7048L93.4287 15.581C94.5907 14.5651 95.8883 13.7651 97.3214 13.181C98.7545 12.5841 100.284 12.2857 101.911 12.2857C103.254 12.2857 104.506 12.5143 105.668 12.9714C106.843 13.4286 107.786 14.1143 108.496 15.0286C109.219 15.9429 109.58 17.073 109.58 18.419C109.58 19.3841 109.367 20.2921 108.941 21.1429C108.528 21.9937 107.863 22.8 106.947 23.5619L106.888 22.0762C107.599 22.3683 108.199 22.7746 108.69 23.2952C109.193 23.8159 109.574 24.4254 109.832 25.1238C110.103 25.8222 110.239 26.5651 110.239 27.3524C110.239 28.7873 109.851 30 109.077 30.9905C108.302 31.981 107.269 32.7302 105.978 33.2381C104.7 33.746 103.299 34 101.776 34Z" fill="white" />
            <path d="M119.574 34C118.063 34 116.785 33.7206 115.739 33.1619C114.693 32.5905 113.899 31.8349 113.357 30.8952C112.828 29.9556 112.563 28.9206 112.563 27.7905C112.563 26.8 112.731 25.9111 113.067 25.1238C113.402 24.3238 113.919 23.6381 114.616 23.0667C115.313 22.4825 116.217 22.0063 117.327 21.6381C118.166 21.3714 119.148 21.1302 120.271 20.9143C121.407 20.6984 122.634 20.5016 123.951 20.3238C125.28 20.1333 126.668 19.9302 128.114 19.7143L126.449 20.6476C126.462 19.2254 126.139 18.1778 125.481 17.5048C124.822 16.8317 123.712 16.4952 122.15 16.4952C121.207 16.4952 120.297 16.7111 119.419 17.1429C118.541 17.5746 117.928 18.3175 117.579 19.3714L113.318 18.0571C113.835 16.3175 114.816 14.9206 116.262 13.8667C117.721 12.8127 119.684 12.2857 122.15 12.2857C124.009 12.2857 125.642 12.5841 127.049 13.181C128.469 13.7778 129.522 14.7556 130.206 16.1143C130.58 16.8381 130.806 17.581 130.884 18.3429C130.961 19.0921 131 19.9111 131 20.8V33.4286H126.914V28.9714L127.592 29.6952C126.649 31.181 125.545 32.273 124.28 32.9714C123.027 33.6571 121.459 34 119.574 34ZM120.503 30.3429C121.562 30.3429 122.466 30.1587 123.215 29.7905C123.964 29.4222 124.557 28.9714 124.996 28.4381C125.448 27.9048 125.752 27.4032 125.907 26.9333C126.152 26.3492 126.287 25.6825 126.313 24.9333C126.352 24.1714 126.371 23.5556 126.371 23.0857L127.805 23.5048C126.397 23.7206 125.19 23.9111 124.183 24.0762C123.176 24.2413 122.311 24.4 121.588 24.5524C120.865 24.6921 120.226 24.8508 119.671 25.0286C119.128 25.219 118.67 25.4413 118.296 25.6952C117.921 25.9492 117.631 26.2413 117.424 26.5714C117.23 26.9016 117.134 27.2889 117.134 27.7333C117.134 28.2413 117.263 28.6921 117.521 29.0857C117.779 29.4667 118.154 29.7714 118.644 30C119.148 30.2286 119.767 30.3429 120.503 30.3429Z" fill="white" />
        </svg>
    );
}

export const HeaderLogoMob = () => {
    return (
        <svg width="114" height="24" viewBox="0 0 114 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="95.2941" width="4.23529" height="4.23529" fill="#FF8585" />
            <rect x="102.353" width="4.23529" height="4.23529" fill="#FFB84F" />
            <rect x="109.412" width="4.23529" height="4.23529" fill="#7AE448" />
            <path d="M0 23.5966V4.23529H15.9534V23.5966H12.6588V7.27395H3.29458V23.5966H0Z" fill="white" />
            <path d="M25.7588 24C24.2824 24 22.9928 23.6728 21.89 23.0185C20.7873 22.3641 19.9306 21.4633 19.32 20.316C18.7185 19.1597 18.4177 17.833 18.4177 16.3361C18.4177 14.8123 18.7276 13.4767 19.3473 12.3294C19.9671 11.1821 20.8283 10.2857 21.931 9.64033C23.0338 8.99495 24.3097 8.67227 25.7588 8.67227C27.2443 8.67227 28.5384 8.99944 29.6412 9.65378C30.7439 10.3081 31.6006 11.2134 32.2112 12.3697C32.8218 13.5171 33.1271 14.8392 33.1271 16.3361C33.1271 17.842 32.8173 19.1731 32.1976 20.3294C31.5869 21.4767 30.7303 22.3776 29.6275 23.0319C28.5248 23.6773 27.2352 24 25.7588 24ZM25.7588 20.9613C27.0711 20.9613 28.0463 20.5311 28.6842 19.6706C29.3222 18.8101 29.6412 17.6986 29.6412 16.3361C29.6412 14.9288 29.3176 13.8084 28.6706 12.9748C28.0235 12.1322 27.0529 11.7109 25.7588 11.7109C24.8747 11.7109 24.1457 11.9081 23.5715 12.3025C23.0064 12.688 22.5872 13.2302 22.3138 13.9294C22.0404 14.6196 21.9037 15.4218 21.9037 16.3361C21.9037 17.7434 22.2272 18.8683 22.8743 19.7109C23.5305 20.5445 24.492 20.9613 25.7588 20.9613Z" fill="white" />
            <path d="M34.2253 23.5966V20.8807C34.763 20.9793 35.1776 20.9703 35.4693 20.8538C35.7609 20.7283 35.9796 20.4952 36.1255 20.1546C36.2713 19.814 36.3989 19.3613 36.5082 18.7966C36.6541 17.9989 36.7816 17.0801 36.891 16.0403C37.0095 15.0006 37.1097 13.8891 37.1918 12.7059C37.2829 11.5227 37.3649 10.3126 37.4378 9.07563H48.3058V23.5966H45.0249V12.1143H40.336C40.2904 12.6969 40.2357 13.3513 40.1719 14.0773C40.1081 14.7944 40.0398 15.5204 39.9669 16.2555C39.8939 16.9905 39.8119 17.6896 39.7208 18.3529C39.6388 19.0073 39.5522 19.5675 39.461 20.0336C39.2514 21.0823 38.9507 21.9115 38.5588 22.521C38.176 23.1305 37.6383 23.5204 36.9457 23.6908C36.253 23.87 35.3462 23.8387 34.2253 23.5966Z" fill="white" />
            <path d="M51.5859 23.5966L51.5722 9.07563H54.8668V13.916H57.5189C57.929 13.916 58.3892 13.9249 58.8996 13.9429C59.4191 13.9608 59.852 14.0011 60.1983 14.0639C61.0276 14.2431 61.7339 14.53 62.3172 14.9244C62.9096 15.3188 63.3607 15.8342 63.6706 16.4706C63.9804 17.107 64.1354 17.8734 64.1354 18.7697C64.1354 20.0515 63.7982 21.0779 63.1238 21.8487C62.4585 22.6106 61.5198 23.1305 60.3076 23.4084C59.9431 23.4891 59.4965 23.5429 58.9679 23.5697C58.4485 23.5877 57.9791 23.5966 57.5599 23.5966H51.5859ZM54.8668 21.0555H57.847C58.0475 21.0555 58.2707 21.0465 58.5168 21.0286C58.7629 21.0106 58.9998 20.9703 59.2277 20.9076C59.6378 20.8 59.9978 20.558 60.3076 20.1815C60.6266 19.7961 60.7861 19.3255 60.7861 18.7697C60.7861 18.1871 60.6266 17.7076 60.3076 17.3311C59.9887 16.9546 59.5968 16.7081 59.132 16.5916C58.9224 16.5378 58.7036 16.502 58.4758 16.484C58.248 16.4661 58.0383 16.4571 57.847 16.4571H54.8668V21.0555Z" fill="white" />
            <path d="M71.8417 24C70.4382 24 69.1577 23.7087 68.0003 23.126C66.8428 22.5434 65.9315 21.7457 65.2662 20.7328L67.8636 19.0252C68.3921 19.6437 68.98 20.1232 69.627 20.4639C70.2741 20.7955 70.9941 20.9613 71.787 20.9613C72.6163 20.9613 73.2679 20.7821 73.7418 20.4235C74.2158 20.065 74.4527 19.5854 74.4527 18.9849C74.4527 18.456 74.2932 18.084 73.9742 17.8689C73.6553 17.6448 73.236 17.5104 72.7166 17.4655C72.1971 17.4207 71.6412 17.3983 71.0488 17.3983H69.9551V14.8302H71.0351C71.8644 14.8302 72.5571 14.7361 73.113 14.5479C73.6781 14.3597 73.9606 13.9429 73.9606 13.2975C73.9606 12.7148 73.7418 12.3025 73.3044 12.0605C72.8669 11.8095 72.3566 11.684 71.7733 11.684C71.0624 11.684 70.3607 11.8319 69.6681 12.1277C68.9754 12.4235 68.3557 12.7821 67.8089 13.2034L65.9497 10.9983C66.7699 10.2812 67.6858 9.71652 68.6975 9.3042C69.7091 8.88291 70.789 8.67227 71.9373 8.67227C72.8852 8.67227 73.7692 8.83361 74.5894 9.1563C75.4188 9.47899 76.0841 9.96302 76.5853 10.6084C77.0957 11.2538 77.3509 12.0515 77.3509 13.0017C77.3509 13.6829 77.2005 14.3238 76.8997 14.9244C76.6081 15.5249 76.1387 16.0941 75.4917 16.6319L75.4507 15.5832C75.9519 15.7894 76.3757 16.0762 76.722 16.4437C77.0774 16.8112 77.3463 17.2415 77.5286 17.7344C77.72 18.2274 77.8156 18.7518 77.8156 19.3076C77.8156 20.3204 77.5422 21.1765 76.9954 21.8756C76.4486 22.5748 75.7195 23.1036 74.8081 23.4622C73.9059 23.8207 72.9171 24 71.8417 24Z" fill="white" />
            <path d="M84.405 24C83.3387 24 82.4365 23.8028 81.6983 23.4084C80.9601 23.005 80.3996 22.4717 80.0168 21.8084C79.6431 21.1451 79.4563 20.4146 79.4563 19.6168C79.4563 18.9176 79.5748 18.2902 79.8117 17.7344C80.0487 17.1697 80.4132 16.6857 80.9054 16.2823C81.3975 15.87 82.0355 15.5339 82.8192 15.2739C83.4116 15.0857 84.1043 14.9154 84.8972 14.763C85.6992 14.6106 86.565 14.4717 87.4945 14.3462C88.4332 14.2118 89.413 14.0683 90.4337 13.916L89.258 14.5748C89.2671 13.5709 89.0393 12.8314 88.5745 12.3563C88.1097 11.8812 87.3259 11.6437 86.2232 11.6437C85.5579 11.6437 84.9154 11.7961 84.2957 12.1008C83.6759 12.4056 83.243 12.93 82.997 13.6739L79.9895 12.7462C80.354 11.5182 81.0466 10.5322 82.0674 9.78823C83.0972 9.04425 84.4825 8.67227 86.2232 8.67227C87.5356 8.67227 88.6884 8.88291 89.6818 9.3042C90.6843 9.72549 91.4271 10.4157 91.9101 11.3748C92.1744 11.8857 92.3339 12.4101 92.3886 12.9479C92.4432 13.4767 92.4706 14.0549 92.4706 14.6823V23.5966H89.5861V20.4504L90.0646 20.9613C89.3993 22.0101 88.6201 22.7809 87.7269 23.2739C86.8429 23.758 85.7356 24 84.405 24ZM85.0612 21.4185C85.8085 21.4185 86.4465 21.2885 86.9751 21.0286C87.5037 20.7686 87.9229 20.4504 88.2327 20.0739C88.5517 19.6975 88.7659 19.3434 88.8753 19.0118C89.0484 18.5994 89.1441 18.1288 89.1623 17.6C89.1897 17.0622 89.2033 16.6274 89.2033 16.2958L90.215 16.5916C89.2216 16.744 88.3695 16.8784 87.6586 16.995C86.9477 17.1115 86.3371 17.2235 85.8267 17.3311C85.3164 17.4297 84.8653 17.5417 84.4734 17.6672C84.0906 17.8017 83.7671 17.9585 83.5028 18.1378C83.2385 18.3171 83.0334 18.5232 82.8876 18.7563C82.7509 18.9894 82.6825 19.2627 82.6825 19.5765C82.6825 19.935 82.7737 20.2532 82.9559 20.5311C83.1382 20.8 83.4025 21.0151 83.7488 21.1765C84.1043 21.3378 84.5417 21.4185 85.0612 21.4185Z" fill="white" />
        </svg>

    );
}

export const PhoneIcon = () => {
    return (
        <svg
            width={32}
            height={32}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M26.015 22.672l-1.692-1.691a2.161 2.161 0 00-3.057 0l-1.33 1.33a1.024 1.024 0 01-1.13.227c-1.925-.843-3.828-2.122-5.525-3.819-1.69-1.69-2.964-3.584-3.809-5.502a1.057 1.057 0 01.234-1.17l1.19-1.19c.968-.968.968-2.336.123-3.18L9.328 5.986a2.883 2.883 0 00-4.077 0l-.94.938c-1.068 1.068-1.513 2.61-1.225 4.137.712 3.767 2.9 7.892 6.43 11.422 3.531 3.53 7.656 5.719 11.423 6.431 1.528.288 3.069-.157 4.137-1.225l.939-.939a2.884 2.884 0 000-4.078zM17.415 8.805c1.487-.02 2.98.53 4.115 1.665M25.607 6.394A11.55 11.55 0 0017.415 3M23.195 14.585a5.686 5.686 0 00-1.665-4.115M25.607 6.394A11.55 11.55 0 0129 14.584"
                stroke="#fff"
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export const PhoneIconTablet = () => {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19.51 17.004l-1.267-1.268a1.621 1.621 0 00-2.294 0l-.996.997a.768.768 0 01-.848.17c-1.445-.632-2.872-1.591-4.144-2.864-1.268-1.267-2.223-2.688-2.857-4.127a.793.793 0 01.175-.877l.893-.893c.726-.725.726-1.751.092-2.385L6.996 4.49a2.162 2.162 0 00-3.058 0l-.705.704c-.8.801-1.135 1.957-.919 3.103.534 2.825 2.176 5.918 4.824 8.566 2.647 2.648 5.74 4.29 8.566 4.824 1.146.216 2.302-.118 3.103-.92l.704-.703a2.163 2.163 0 000-3.06zM13.062 6.604a4.264 4.264 0 013.085 1.249M19.205 4.795a8.662 8.662 0 00-6.143-2.545M17.396 10.938a4.264 4.264 0 00-1.249-3.085M19.205 4.795a8.662 8.662 0 012.545 6.143"
                stroke="#fff"
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export const EmailIcon = () => {
    return (
        <svg
            width={32}
            height={32}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23.222 6H8.778C5.587 6 3 8.388 3 11.333v9.334C3 23.612 5.587 26 8.778 26h14.444C26.413 26 29 23.612 29 20.667v-9.334C29 8.388 26.413 6 23.222 6z"
                stroke="#fff"
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.778 11.904l6.073 2.49a3.047 3.047 0 002.301.003l6.07-2.468"
                stroke="#fff"
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export const EmailIconTablet = () => {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.417 4.5H6.583c-2.393 0-4.333 1.79-4.333 4v7c0 2.21 1.94 4 4.333 4h10.834c2.393 0 4.333-1.79 4.333-4v-7c0-2.21-1.94-4-4.333-4z"
                stroke="#fff"
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.583 8.928l4.556 1.867a2.284 2.284 0 001.725.002l4.553-1.85"
                stroke="#fff"
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export const HeaderMenuMobOpenBtn = () => {
    return (
        <svg
            width={23}
            height={22}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.583 4H21l-1.583 2H2l1.583-2zM3.429 10H12l-1.429 2H2l1.429-2zM3.583 16H21l-1.583 2H2l1.583-2z"
                fill="#fff"
            />
        </svg>
    );
}

export const HeaderMenuMobCloseBtn = () => {
    return (
        <svg
            width={23}
            height={22}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.12 17.316L17.435 5l.295 2.534L5.414 19.849l-.294-2.534z"
                fill="#fff"
            />
            <path
                d="M17.73 17.316L5.414 5 5.12 7.534l12.315 12.315.295-2.534z"
                fill="#fff"
            />
        </svg>
    );
}

export const PopupHeaderEmailIcon = () => {
    return (
        <svg
            width={44}
            height={44}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M30.462 10.154H13.538c-3.738 0-6.769 2.828-6.769 6.318v11.056c0 3.49 3.03 6.318 6.77 6.318h16.923c3.738 0 6.769-2.829 6.769-6.318V16.472c0-3.49-3.03-6.318-6.77-6.318z"
                stroke="#fff"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.539 17.148l7.115 2.949a3.534 3.534 0 002.696.004l7.111-2.924"
                stroke="#fff"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export const PopupHeaderPhoneIcon = () => {
    return (
        <svg
            width={44}
            height={44}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M32.43 28.948l-1.762-1.76a2.25 2.25 0 00-3.184 0L26.1 28.571c-.31.309-.778.412-1.177.237-2.006-.879-3.988-2.21-5.755-3.977-1.76-1.76-3.087-3.733-3.966-5.73a1.1 1.1 0 01.243-1.218l1.24-1.24c1.007-1.008 1.007-2.432.128-3.312l-1.761-1.761a3.002 3.002 0 00-4.246 0l-.979.977c-1.112 1.113-1.576 2.717-1.276 4.309.742 3.923 3.02 8.218 6.697 11.895 3.677 3.676 7.972 5.955 11.895 6.697 1.592.3 3.197-.164 4.309-1.276l.977-.977a3.004 3.004 0 000-4.248zM23.474 14.507a5.921 5.921 0 014.285 1.734M32.005 11.996a12.028 12.028 0 00-8.53-3.534M29.492 20.526a5.921 5.921 0 00-1.733-4.285M32.005 11.996a12.028 12.028 0 013.533 8.53"
                stroke="#fff"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export const DiagramIcon = () => {
    return (
        <svg
            width={240}
            height={240}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#prefix__clip0_1146_1810)">
                <path
                    d="M150.906 90.094c16.792 16.793 16.792 44.019 0 60.812-16.793 16.792-44.019 16.792-60.812 0-16.792-16.793-16.792-44.019 0-60.812 16.793-16.792 44.019-16.792 60.812 0z"
                    fill="url(#prefix__paint0_linear_1146_1810)"
                />
                <path
                    d="M120.5 106.055V120.5M130.709 110.29c5.639 5.639 5.639 14.783 0 20.422-5.639 5.639-14.782 5.639-20.421 0-5.64-5.639-5.64-14.783 0-20.422"
                    stroke="#67E4FF"
                    strokeWidth={4}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M120 50.788c-38.225 0-69.212 30.987-69.212 69.212 0 38.225 30.987 69.212 69.212 69.212 38.225 0 69.212-30.987 69.212-69.212 0-38.225-30.987-69.212-69.212-69.212zM0 120C0 53.726 53.726 0 120 0s120 53.726 120 120-53.726 120-120 120S0 186.274 0 120z"
                    fill="url(#prefix__paint1_linear_1146_1810)"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M189.212 120c0-38.225-30.987-69.212-69.212-69.212V0c66.274 0 120 53.726 120 120 0 9.529-1.116 18.83-3.235 27.767l-49.418-11.717a69.497 69.497 0 001.865-16.05z"
                    fill="#2D42FD"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M182.111 89.416C170.787 66.478 147.202 50.788 120 50.788V0c47.265 0 88.1 27.33 107.652 66.933l-45.541 22.483z"
                    fill="#2D8DFD"
                />
            </g>
            <defs>
                <linearGradient
                    id="prefix__paint0_linear_1146_1810"
                    x1={120.5}
                    y1={-103}
                    x2={120.5}
                    y2={206.5}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#5400DE" />
                    <stop offset={1} stopColor="#C5A2FF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="prefix__paint1_linear_1146_1810"
                    x1={120}
                    y1={183}
                    x2={120}
                    y2={-22}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#5321BE" />
                    <stop offset={1} stopColor="#1A205E" stopOpacity={0.38} />
                </linearGradient>
                <clipPath id="prefix__clip0_1146_1810">
                    <path fill="#fff" d="M0 0h240v240H0z" />
                </clipPath>
            </defs>
        </svg>
    );
}

export const SuiteRhombsIcon = () => {
    return (
        <svg
            width={200}
            height={215}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M123.563.893l73.808 92.866a12.13 12.13 0 012.629 7.546v110.811c0 1.903-2.381 2.744-3.562 1.258l-73.807-92.867a12.12 12.12 0 01-2.63-7.545V2.15c0-1.903 2.381-2.743 3.562-1.257z"
                fill="#7AE448"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M63.567.893l73.808 92.866a12.13 12.13 0 012.629 7.546v110.811c0 1.903-2.38 2.744-3.561 1.258l-73.808-92.867a12.125 12.125 0 01-2.63-7.545V2.15c0-1.903 2.38-2.743 3.562-1.257z"
                fill="#FFB84F"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.562.893L77.37 93.759a12.13 12.13 0 012.629 7.546v110.811c0 1.903-2.38 2.744-3.562 1.258L2.63 120.507A12.125 12.125 0 010 112.962V2.15C0 .247 2.38-.593 3.562.893z"
                fill="#FF8585"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M120 71.903l17.37 21.855a12.13 12.13 0 012.63 7.546v41.058l-17.37-21.855a12.126 12.126 0 01-2.63-7.546V71.903z"
                fill="#B1FF4F"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M60.005 71.903l17.37 21.855a12.129 12.129 0 012.63 7.546v41.058l-17.37-21.855a12.13 12.13 0 01-2.63-7.546V71.903z"
                fill="#FFD585"
            />
        </svg>
    );
}

export const NumbersRhombIcon = () => {
    return (
        <svg
            width={1393}
            height={2691}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M696.5 0L0 1345.5 696.5 2691 1393 1345.5 696.5 0z"
                fill="#1F2664"
            />
        </svg>
    );
}

export const CrossFeedbackIcon = () => {
    return (
        <svg
            width={24}
            height={24}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3 21L21 3M21 21L3 3"
                stroke="#000536"
                strokeWidth={2}
                strokeLinecap="round"
            />
        </svg>
    );
}

export const SuccessMonitorIcon = () => {
    return (
        <svg
            width={278}
            height={328}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx={142} cy={166} r={124} fill="#C8C7FF" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.735 226.5C63.522 203.014 101.125 189 142 189c40.876 0 78.478 14.014 108.265 37.5C229.047 264.389 188.514 290 142 290s-87.046-25.611-108.265-63.5z"
                fill="#AFADFF"
            />
            <g filter="url(#prefix__filter0_d_794_7729)">
                <g clipPath="url(#prefix__clip0_794_7729)">
                    <rect x={62} y={41} width={160} height={110} rx={16} fill="#8A94F0" />
                    <path d="M34 157h216L142 76 34 157z" fill="#818BEB" />
                    <path d="M62 41h160l-80 60-80-60z" fill="#A4ADFF" />
                    <rect x={119} y={127} width={10} height={10} rx={2} fill="#FF8585" />
                    <rect x={137} y={127} width={10} height={10} rx={2} fill="#FFB84F" />
                    <rect x={155} y={127} width={10} height={10} rx={2} fill="#7AE448" />
                </g>
            </g>
            <path
                d="M142 166v79M126 166v39M126 215v10M172 196v7M157 203v17M157 166v27M172 184v-9.391c0-5.523 4.477-10 10-10h36c9.941 0 18-8.059 18-18V45c0-9.941-8.059-18-18-18H66c-9.941 0-18 8.059-18 18v101.609c0 9.941 8.059 18 18 18h36c5.523 0 10 4.477 10 10V193"
                stroke="#593FF8"
                strokeWidth={3}
                strokeLinecap="round"
            />
            <path
                d="M18 20l5.091 12.909L36 38l-12.909 5.091L18 56l-5.091-12.909L0 38l12.909-5.091L18 20z"
                fill="#569AFF"
            />
            <path
                d="M61.5 245l3.818 9.682L75 258.5l-9.682 3.818L61.5 272l-3.818-9.682L48 258.5l9.682-3.818L61.5 245z"
                fill="#7A77F4"
            />
            <path
                d="M141.5 307l2.97 7.53 7.53 2.97-7.53 2.97-2.97 7.53-2.97-7.53-7.53-2.97 7.53-2.97 2.97-7.53z"
                fill="#3935FF"
            />
            <path
                d="M265 157l3.677 9.323L278 170l-9.323 3.677L265 183l-3.677-9.323L252 170l9.323-3.677L265 157z"
                fill="#567BFF"
            />
            <circle cx={250.5} cy={59.5} r={3.5} fill="#53BDF9" />
            <circle cx={199.5} cy={228.5} r={3.5} fill="#8991E9" />
            <circle cx={40} cy={184} r={5} fill="#8991E9" />
            <circle cx={142} cy={5} r={5} fill="#5867FF" />
            <defs>
                <clipPath id="prefix__clip0_794_7729">
                    <rect x={62} y={41} width={160} height={110} rx={16} fill="#fff" />
                </clipPath>
                <filter
                    id="prefix__filter0_d_794_7729"
                    x={42}
                    y={29}
                    width={200}
                    height={150}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={8} />
                    <feGaussianBlur stdDeviation={10} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix values="0 0 0 0 0.357049 0 0 0 0 0.392878 0 0 0 0 0.758333 0 0 0 0.4 0" />
                    <feBlend
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_794_7729"
                    />
                    <feBlend
                        in="SourceGraphic"
                        in2="effect1_dropShadow_794_7729"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}

